module.exports = "/lucky-balls/img/regular_game/header_winbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_winbet.png
// module id = 1151
// module chunks = 0